import {PageHeader, Popout, Dropdown, DropdownItem, EitjeButton, SearchInput as BaseSearchInput} from '~/components'
import {t} from '~/initializers/i18n'

export const SearchPageHeader = ({headerLabel, count, searchDropdownProps, searchInputProps, searchExplanationPopoutProps}) => {
	const displayLabel = count !== undefined ? `${count} ${t(headerLabel)}` : headerLabel

	return (
		<PageHeader
			label={displayLabel}
			left={[<SearchDropdown key={0} {...searchDropdownProps} />, <SearchInput key={1} {...searchInputProps} />]}
			right={<SearchExplanationPopout {...searchExplanationPopoutProps} />}
		/>
	)
}

const SearchDropdown = ({triggerText}) => {
	return (
		<Dropdown trigger={<EitjeButton height="small" iconRight="chevron-small-down" t={triggerText} />}>
			<DropdownItem t="firm.search" to="/search/firm" />
			<DropdownItem t="user.search" to="/search/user" />
			<DropdownItem t="invoice.search" to="/search/invoice" />
		</Dropdown>
	)
}

const SearchInput = ({searchValue, handleChange, handleKeyDown, handleClear}) => {
	return <BaseSearchInput height={32} value={searchValue} onChange={handleChange} onKeyDown={handleKeyDown} onClear={handleClear} />
}

const SearchExplanationPopout = ({title, body}) => {
	return <Popout trigger={{t: 'common.explanation', height: 'small', colorSet: 'solid', baseColor: 'pink'}} title={title} body={body} />
}
